module.exports = __webpack_public_path__ + "img/corp_vat_definition.3800dc97.png";